// extracted by mini-css-extract-plugin
module.exports = {"banner":"w_2","bannerContent":"w_cB","title":"w_l","description":"w_F","button":"w_R","logosContainer":"w_cC","uses":"w_bZ"};